export default __webpack_public_path__ + "static/media/cleanproCuciBm.055b8972.jpg";